// src/components/MessageThread.js
import React, { useEffect, useMemo, useState } from "react";
import styles from "../Styles/Servicerequests.module.css";
import IconButton from "../Images/IconButton";
import { fmtDateTime } from "../Utils/dates";

export default function MessageThread({
  messages = [],
  pageSize = 5,
  resetOn,
  canDeleteMessage, // ✅ uusi (optional)
  onDeleteMessage,  // ✅ uusi (optional)
}) {
  const [page, setPage] = useState(0);

  // resetoi sivu kun pyynnön id vaihtuu
  useEffect(() => {
    setPage(0);
  }, [resetOn]);

  // uusin ensin
  const sorted = useMemo(
    () => [...messages].sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)),
    [messages]
  );

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const start = page * pageSize;
  const pageItems = sorted.slice(start, start + pageSize);

  if (!sorted.length) {
    return <div className={styles.muted}>Ei viestejä vielä.</div>;
  }

  return (
    <>
      <div className={styles.thread}>
        {pageItems.map((m) => {
          const deletable =
            typeof canDeleteMessage === "function" ? !!canDeleteMessage(m) : false;

          const body =
            m?.isDeleted ? "Viesti poistettu" : (m?.body || "");

          return (
            <div key={m.id} className={styles.msg}>
              <div className={styles.msgHeader}>
                <div className={styles.msgSender}>
                  {m.senderName || m.createdBy?.name || "—"}
                </div>

                <div className={styles.msgMeta}>
                  {m.visibility === "internal" && (
                    <span
                      className={`${styles.filterPillTiny} ${styles.badgeWarn}`}
                    >
                      Sisäinen
                    </span>
                  )}
                  <span className={styles.mutedSmall}>
                    {fmtDateTime(m.createdAt)}
                  </span>

                  {deletable && typeof onDeleteMessage === "function" && (
                    <button
                      type="button"
                      className={styles.iconDeleteBtn}
                      onClick={() => onDeleteMessage(m.id)}
                      title="Poista viesti"
                      aria-label="Poista viesti"
                    >
                      {/* inline trash icon (ei uusia riippuvuuksia) */}
                      <svg
                        viewBox="0 0 24 24"
                        width="16"
                        height="16"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 7h2v9h-2v-9zm4 0h2v9h-2v-9zM7 10h2v9H7v-9zm-1-1h12l-1 12H7L6 9z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <div className={styles.msgBodySmall} style={m.isDeleted ? { fontStyle: "italic", opacity: 0.75 } : undefined}>
               {m.isDeleted ? "Viesti poistettu" : (m.body || "")}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.msgPager}>
        <IconButton
          direction="left"
          onClick={() => setPage((p) => Math.max(0, p - 1))}
          disabled={page <= 0}
        />
        <span className={styles.pageCounterSmall}>
          {page + 1} / {totalPages}
        </span>
        <IconButton
          direction="right"
          onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
          disabled={page >= totalPages - 1}
        />
      </div>
    </>
  );
}